import { useEffect, useLayoutEffect, useState } from 'react';

const useIsomorphicLayoutEffect =
    typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export const useRootElement = (query: string) => {
    const [node, setNode] = useState<Element | null>(null);

    useIsomorphicLayoutEffect(() => {
        setNode(document.querySelector(query));
    }, []);

    return node;
};
